import { Trans } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { IActionFormProps } from '@makyoapp/makyo-common'
import { Button, ButtonVariant, Field, Label, Radio } from '@makyoapp/makyo-ui'

import { useForm } from '@/lib/use-form'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { isEmpty } from '@/shared/utils'
import { ActionInputV3 } from '@/components/ActionInputV3/ActionInputV3'

import { TableSelect } from '../../shared/TableSelect'

export default function ActFormWA({ onSubmit, onDismiss, initialData, triggerSource }: IActionFormProps) {
  const { tables } = useDbClientContext()
  // create table options
  const tblOptions = tables

  const shouldShowTable = ['menu-item'].includes(triggerSource)
  const defaultTableId = shouldShowTable ? (!!tblOptions.length ? tblOptions[0]?.id : '') : undefined

  const { form, onSubmit: onFormSubmit } = useForm({
    defaultValues: {
      phone: initialData?.phone || {},
      message: initialData?.message || {},
      tableId: initialData?.tableId ?? defaultTableId ?? '',
      business: initialData?.business ?? true,
    },
    validate(data, setError) {
      let isManualInput = !data.phone.tableId && !data.phone.dataType
      let phoneValue = data.phone?.value as string
      let isPhoneEmpty = !phoneValue?.trim().length
      let validPhoneInput = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]{8,14}$/g.test(phoneValue)

      let phoneError = isPhoneEmpty
        ? 'Phone number cannot be empty'
        : isManualInput && !validPhoneInput
          ? 'Please enter a valid phone number'
          : null

      setError('phone', phoneError)
    },
  })
  const phone = form.getValues('phone')
  const tableId = form.getValues('tableId')

  const invalidForm = isEmpty(phone) || !!form.errors || (shouldShowTable && isEmpty(tableId))

  const handleSubmit = onFormSubmit((data) => {
    onSubmit(data)
  })

  return (
    <div>
      <div className='p-4'>
        {shouldShowTable && (
          <Field className='min-h-0'>
            <Label required>Table</Label>

            <TableSelect
              options={tblOptions}
              value={tblOptions.find((tb) => tb.id === form.getValues('tableId'))}
              onChange={(tb) => {
                form.setValues('tableId', tb.id)
              }}
              error={form.errors?.tableId}
            />
          </Field>
        )}

        <Field>
          <Label required>Phone</Label>
          <ActionInputV3
            options={initialData?.actionOptions}
            isActionWorkflow={initialData?.isActionWorkflow}
            globalTableId={shouldShowTable ? form.getValues('tableId') : undefined}
            placeholder='Enter Phone'
            value={form.getValues('phone')}
            columnTypes={[ColumnTypes.Phone]}
            onChange={({ ...value }) => {
              form.setValues('phone', value)
            }}
            error={form.errors?.phone}
          />
        </Field>

        <Field>
          <Label>Account Type</Label>
          <div className='flex items-center gap-6'>
            <Radio
              name='wa-account-type'
              value='business'
              checked={!!form.getValues('business')}
              onClick={() => form.setValues('business', true)}
              label='Business'
            />
            <Radio
              name='wa-account-type'
              value='personal'
              checked={!form.getValues('business')}
              onClick={() => form.setValues('business', false)}
              label='Personal'
            />
          </div>
        </Field>

        <Field>
          <Label>Message</Label>
          <ActionInputV3
            options={initialData?.actionOptions}
            isActionWorkflow={initialData?.isActionWorkflow}
            globalTableId={shouldShowTable ? form.getValues('tableId') : undefined}
            placeholder='Message goes here'
            inputType='textarea'
            value={form.getValues('message')}
            columnTypes={[ColumnTypes.Text, ColumnTypes.RichText, ColumnTypes.Join]}
            onChange={({ ...value }) => {
              form.setValues('message', value)
            }}
            error={form.errors?.message}
          />
        </Field>
      </div>

      <div className='px-4 py-2 border-t bdr flex justify-between items-center'>
        <Button variant={ButtonVariant.Outlined} onClick={onDismiss}>
          <Trans>Cancel</Trans>
        </Button>
        <Button onClick={handleSubmit} disabled={invalidForm}>
          <Trans>Save</Trans>
        </Button>
      </div>
    </div>
  )
}
